import {
    LogisticsEstimateWithAccountInfo,
    PaginatedLogisticsEstimatesWithAccountInfo,
} from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { RefObject } from 'react'

import { LogisticsEmissionCalculationRow } from 'views/CalculateEmissions/index'

const LogisticsEmissionCalculationTable = ({
    paginatedEstimates,
    currentPage,
    pageHistoryRef,
    queryParams,
    loading,
}: {
    paginatedEstimates?: PaginatedLogisticsEstimatesWithAccountInfo
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    loading: boolean
}) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedEstimates?.data.length ? '1000px' : 'auto' }}
                stickyHeader
                loading={!paginatedEstimates || loading}
                empty={!loading && !paginatedEstimates?.data.length}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={2}>Origin</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Destination</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Date</TableNew.TableCell>
                        <TableNew.TableCell colSize={1}>Source</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Client account</TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            Legs
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {paginatedEstimates?.data.map(
                            (calculation: LogisticsEstimateWithAccountInfo, i: number) => (
                                <LogisticsEmissionCalculationRow
                                    key={i}
                                    calculation={calculation}
                                    currentPage={currentPage}
                                    pageHistoryRef={pageHistoryRef}
                                    queryParams={queryParams}
                                />
                            ),
                        )}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default LogisticsEmissionCalculationTable
